(function () {
    'use strict';

    angular
        .module('appback')
        .controller('IncidenceController', IncidenceController);

    IncidenceController.$inject = ["IncidenceService", "$scope"];

    // Traduce un texto (clave en inglés) con el diccionario de report.twig y sustituye los {parámetros}.
    function tr(text, params) {
        var dict = window.incidenceI18n || {};
        var result = dict[text] || text;

        angular.forEach(params || {}, function (value, key) {
            result = result.split('{' + key + '}').join(value);
        });

        return result;
    }

    // Página "Reportar incidencia" (incidence/report.twig): mismo reporte que el
    // del dashboard de líneas, eligiendo la línea en el formulario.
    function IncidenceController(IncidenceService, $scope) {

        var vm = this;

        vm.loading = true;
        vm.saving = false;
        vm.submitted = false;

        vm.lines = [];
        vm.machines = [];
        vm.incidenceTypes = [];
        vm.shifts = [];
        vm.maintenanceApplications = [];
        vm.detectionMethods = [];
        vm.boards = [];

        // Aviso tras enviar o al fallar una carga. type: 'success' | 'error' | 'warning'.
        vm.alert = null;

        vm.form = {};

        // Imágenes del reporte: subidas desde el dispositivo o capturadas de una
        // cámara de la línea. Cada una: { file: File|Blob, name, url (vista previa) }.
        vm.images = [];

        vm.cameraPicker = { open: false, loading: false, cameras: [], capturing: null, stamp: Date.now() };

        vm.locationPicker = { search: '' };

        vm.locationTemplates = { loading: false, loaded: false, items: [] };

        var defaultBoard = function () {
            return vm.boards.find(function (board) {
                return board.is_default;
            }) || vm.boards[0] || null;
        };

        vm.resetForm = function () {
            var now = new Date();

            vm.form = {
                line: null,
                machine: null,
                exactLocation: false,
                incidenceType: null,
                shift: null,
                // hora actual por defecto (input type="time" trabaja con Date)
                incidenceTime: new Date(1970, 0, 1, now.getHours(), now.getMinutes()),
                detectionMethod: null,
                maintenanceApplication: null,
                kanbanBoard: defaultBoard(),
                observations: ''
            };

            vm.submitted = false;
            vm.clearImages();
            vm.cameraPicker.open = false;
            vm.locationPicker.search = '';
            vm.locationTemplates = { loading: false, loaded: false, items: [] };
        };

        vm.load = function () {
            vm.loading = true;

            IncidenceService.GetFormData().then(function (data) {
                vm.lines = data.lines || [];
                vm.machines = (data.machines || []).sort(function (a, b) {
                    return vm.locationLabel(a).localeCompare(vm.locationLabel(b));
                });
                vm.incidenceTypes = data.incidence_types || [];
                vm.shifts = data.shifts || [];
                vm.maintenanceApplications = data.maintenance_applications || [];
                vm.detectionMethods = data.detection_methods || [];
                vm.boards = data.boards || [];

                vm.resetForm();
            }, function () {
                vm.alert = { type: 'error', message: tr('Could not load the form data.') };
            }).finally(function () {
                vm.loading = false;
            });
        };

        // ---- Línea y ubicación ----

        var machineInLine = function (machine, line) {
            return !!line && (machine.lines || []).indexOf(String(line.id)) !== -1;
        };

        var lineById = function (id) {
            return vm.lines.find(function (line) {
                return String(line.id) === String(id);
            }) || null;
        };

        vm.machineLine = function (machine) {
            var lineIds = machine ? (machine.lines || []) : [];

            for (var i = 0; i < lineIds.length; i++) {
                var line = lineById(lineIds[i]);
                if (line) {
                    return line;
                }
            }

            return null;
        };

        vm.machineLocationsText = function (machine) {
            return (machine && machine.ubicaciones ? machine.ubicaciones : []).map(function (location) {
                return location.path || location.name;
            }).join(', ');
        };

        vm.locationLabel = function (machine) {
            return vm.machineLocationsText(machine) + (machine.name ? ' - ' + machine.name : '');
        };

        // Ubicaciones de la línea elegida; sin línea, las de cualquier línea.
        // Cada palabra del buscador tiene que aparecer en la ubicación, el nombre o el código.
        vm.filteredLocations = function () {
            var words = String(vm.locationPicker.search || '').toLowerCase().split(/\s+/).filter(function (word) {
                return word.length;
            });

            return vm.machines.filter(function (machine) {
                if (vm.form.line ? !machineInLine(machine, vm.form.line) : !vm.machineLine(machine)) {
                    return false;
                }

                var text = [vm.machineLocationsText(machine), machine.name, machine.erp_id].join(' ').toLowerCase();

                return words.every(function (word) {
                    return text.indexOf(word) !== -1;
                });
            });
        };

        vm.changeLine = function () {
            if (vm.form.machine && !machineInLine(vm.form.machine, vm.form.line)) {
                vm.selectLocation(null);
            }

            vm.closeCameraPicker();
        };

        vm.selectLocation = function (machine) {
            vm.form.machine = machine;
            vm.locationPicker.search = '';

            // Sin línea elegida: la incidencia toma la de la máquina.
            if (machine && !vm.form.line) {
                vm.form.line = vm.machineLine(machine);
            }

            loadLocationTemplates(machine);
        };

        var locationTemplatesRequest = 0;

        var loadLocationTemplates = function (machine) {
            var request = ++locationTemplatesRequest;

            vm.locationTemplates = { loading: !!machine, loaded: false, items: [] };

            if (!machine) {
                return;
            }

            IncidenceService.GetLocationTemplates(machine.id).then(function (templates) {
                if (request === locationTemplatesRequest) {
                    // Todos seleccionados por defecto; al pulsar uno se deselecciona.
                    vm.locationTemplates.items = (angular.isArray(templates) ? templates : []).map(function (template) {
                        template.selected = true;
                        return template;
                    });
                    vm.locationTemplates.loaded = true;
                }
            }).finally(function () {
                if (request === locationTemplatesRequest) {
                    vm.locationTemplates.loading = false;
                }
            });
        };

        vm.toggleTemplate = function (template) {
            template.selected = !template.selected;
        };

        // Con "ubicación exacta" solo se muestran (y aplican) los de la ubicación completa.
        vm.visibleTemplates = function () {
            return vm.form.exactLocation
                ? vm.locationTemplates.items.filter(function (template) {
                    return template.exact;
                })
                : vm.locationTemplates.items;
        };

        // ---- Imágenes ----

        // El input file está oculto; Angular no soporta ng-change en inputs file.
        vm.pickImageFiles = function () {
            var input = document.getElementById('incidenceReportImageInput');

            if (input) {
                input.onchange = function () {
                    $scope.$apply(function () {
                        angular.forEach(input.files || [], function (file) {
                            if (file.type && file.type.indexOf('image/') === 0) {
                                vm.images.push({ file: file, name: file.name, url: URL.createObjectURL(file) });
                            }
                        });
                    });
                };
                input.value = '';
                input.click();
            }
        };

        // Cámaras de la línea elegida; sin línea no se muestra ninguna.
        vm.openCameraPicker = function () {
            if (!vm.form.line) {
                return;
            }

            if (vm.cameraPicker.open) {
                vm.closeCameraPicker();
                return;
            }

            vm.cameraPicker.open = true;
            vm.cameraPicker.loading = true;
            vm.cameraPicker.cameras = [];
            vm.cameraPicker.stamp = Date.now();

            IncidenceService.GetCameras(vm.form.line.id).then(function (cameras) {
                vm.cameraPicker.cameras = angular.isArray(cameras) ? cameras : [];
            }).finally(function () {
                vm.cameraPicker.loading = false;
            });
        };

        vm.closeCameraPicker = function () {
            vm.cameraPicker.open = false;
        };

        vm.captureCamera = function (camera) {

            if (vm.cameraPicker.capturing) {
                return;
            }

            vm.cameraPicker.capturing = camera.code_camera;

            IncidenceService.GetCameraFrame(camera.code_camera).then(function (blob) {

                var now = new Date();
                var pad = function (n) { return (n < 10 ? '0' : '') + n; };
                var name = (camera.name || camera.code_camera) + '_' + now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate()) + '_' + pad(now.getHours()) + pad(now.getMinutes()) + pad(now.getSeconds()) + '.webp';

                vm.images.push({ file: blob, name: name, url: URL.createObjectURL(blob) });
                vm.cameraPicker.open = false;

            }, function () {
                vm.alert = { type: 'error', message: tr('Could not get the capture from {camera}.', { camera: camera.name || camera.code_camera }) };
            }).finally(function () {
                vm.cameraPicker.capturing = null;
            });
        };

        vm.removeImage = function (index) {
            var image = vm.images[index];

            if (image && image.url) {
                URL.revokeObjectURL(image.url);
            }

            vm.images.splice(index, 1);
        };

        vm.clearImages = function () {
            angular.forEach(vm.images, function (image) {
                if (image.url) {
                    URL.revokeObjectURL(image.url);
                }
            });

            vm.images = [];
        };

        $scope.$on('$destroy', vm.clearImages);

        // ---- Envío ----

        vm.isInvalid = function (field) {
            if (!vm.submitted) {
                return false;
            }

            return !vm.form[field];
        };

        var requiredFields = ['line', 'machine', 'incidenceType', 'shift', 'incidenceTime', 'maintenanceApplication', 'kanbanBoard'];

        vm.submit = function () {
            vm.submitted = true;
            vm.alert = null;

            var missing = requiredFields.some(function (field) {
                return !vm.form[field];
            });

            if (missing || vm.saving) {
                return;
            }

            // hora seleccionada aplicada al dia de hoy, como timestamp
            var incidenceDate = new Date();
            incidenceDate.setHours(vm.form.incidenceTime.getHours(), vm.form.incidenceTime.getMinutes(), 0, 0);

            var data = {
                line: vm.form.line.id,
                machine: vm.form.machine.id,
                incidence_type: vm.form.incidenceType.id,
                shift: vm.form.shift.id,
                incidence_time: Math.floor(incidenceDate.getTime() / 1000),
                detection_method: vm.form.detectionMethod ? vm.form.detectionMethod.id : null,
                maintenance_application: vm.form.maintenanceApplication.id,
                kanban_board: vm.form.kanbanBoard.id,
                exact_location: !!vm.form.exactLocation,
                // Templates seleccionados de los mostrados. Si no se han cargado,
                // no se envían y el backend aplica el más concreto.
                templates: vm.locationTemplates.loaded
                    ? vm.visibleTemplates().filter(function (template) {
                        return template.selected;
                    }).map(function (template) {
                        return template.id;
                    })
                    : null,
                observations: vm.form.observations
            };

            vm.saving = true;

            IncidenceService.ReportIncidence(data, vm.images).then(function (result) {

                var message = tr('Incidence reported successfully.');

                if (result.card_id) {
                    message += ' ' + tr('Card #{id} has been created.', { id: result.card_id });
                } else {
                    message += ' ' + tr('Could not create the kanban card.');
                }

                if (result.failed_images) {
                    message += ' ' + tr('Could not attach {count} images.', { count: result.failed_images });
                }

                vm.alert = { type: result.card_id && !result.failed_images ? 'success' : 'warning', message: message };

                vm.resetForm();

            }, function (error) {
                vm.alert = { type: 'error', message: (error && error.data && error.data.message) || tr('Could not report the incidence.') };
            }).finally(function () {
                vm.saving = false;
            });
        };

        vm.load();
    }
})();
